import { createReducer, on } from '@ngrx/store';
import { ToastSeverity, UiActions } from './ui.actions';

export type ToastNotice = {
  id: number;
  severity: ToastSeverity;
  summary: string;
  detail: string;
};

export type UiState = {
  sidebarCollapsed: boolean;
  globalLoading: boolean;
  toast: ToastNotice | null;
  nextToastId: number;
};

export const initialUiState: UiState = {
  sidebarCollapsed: false,
  globalLoading: false,
  toast: null,
  nextToastId: 1,
};

export const uiReducer = createReducer(
  initialUiState,
  on(UiActions.toggleSidebar, (state) => ({
    ...state,
    sidebarCollapsed: !state.sidebarCollapsed,
  })),
  on(UiActions.setGlobalLoading, (state, { loading }) => ({
    ...state,
    globalLoading: loading,
  })),
  on(UiActions.showToast, (state, { severity, summary, detail }) => ({
    ...state,
    toast: {
      id: state.nextToastId,
      severity,
      summary,
      detail,
    },
    nextToastId: state.nextToastId + 1,
  })),
  on(UiActions.clearToast, (state) => ({
    ...state,
    toast: null,
  })),
);
